<template>
  <b-form-radio-group :checked="value" class="exclude-toggle" size="sm" buttons @change="$emit('input', $event)">
    <b-form-radio :value="false" :button-variant="!value ? 'success' : null">aftrekken van</b-form-radio>
    <b-form-radio :value="true" :button-variant="value ? 'success' : null">optellen bij</b-form-radio>
  </b-form-radio-group>
</template>

<script>
export default {
  props: {
    value: Boolean
  }
}
</script>

<style>
.exclude-toggle .btn {
  padding: 0.2rem 0.5rem;
}

.exclude-toggle input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// ExcludeToggle.vue?1459cbff